import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography,  } from "@material-ui/core";
import t from "../../languages/pl";

const useStyles = theme => ({
    dialogActions: {
        display: 'flex',
        justifyContent: "center",
        alignItems: "center"
    },
    centeredText: {
        textAlign: "center"
    },
});

const InformationDialog = props => {
    const { classes, open, onClose, title, size = "sm" } = props;
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth={size}
            style={{ zIndex: 2001 }}
        >
            <DialogTitle>
                {title}
            </DialogTitle>
            <DialogContent>
                <Typography className={classes.centeredText} variant="body1">
                    {t.possibilityNotSendingSmsInfo}
                </Typography>
                <Typography className={classes.centeredText} variant="body1">
                    {t.possibilityNotSendingSmsInfo2}
                </Typography>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={onClose}
                >
                    {t.understand}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

InformationDialog.propTypes = {
    classes: PropTypes.object,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    title: PropTypes.string,
    content: PropTypes.string,
    size: PropTypes.string,
    omitCheckbox: PropTypes.bool,
    children: PropTypes.node
};

export default withStyles(useStyles)(InformationDialog);